export const commonInitialState = {
  isBackdropShown: false,
  videoUploadData: null,
};
